import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "10",
  "stroke-width": "2",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M25.313 21.563H4.688a1.88 1.88 0 0 1-1.875-1.875v-3.75a3.761 3.761 0 0 1 3.75-3.75h16.875a3.761 3.761 0 0 1 3.75 3.75v3.75a1.88 1.88 0 0 1-1.875 1.875Z" }, null, -1),
    _createElementVNode("path", { d: "M24.375 12.188H5.625L7.5 7.875c.563-1.313 1.875-2.25 3.375-2.25h8.156c1.5 0 2.813.938 3.469 2.25l1.875 4.313ZM9.375 21.563H3.75v1.875a1.88 1.88 0 0 0 1.875 1.875H7.5a1.88 1.88 0 0 0 1.875-1.875v-1.875ZM26.25 21.563h-5.625v1.875a1.88 1.88 0 0 0 1.875 1.875h1.875a1.88 1.88 0 0 0 1.875-1.875v-1.875ZM2.813 11.25H6M24.375 11.25h2.813M19.688 21.563h-9.375l1.312-2.72c.281-.655.938-1.03 1.688-1.03h3.28c.75 0 1.407.375 1.688 1.03l1.407 2.72ZM5.625 16.875h2.813M21.563 16.875h2.812" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "vehicule"}) } }